import { formatAmount } from "../../../../utils/hooks/dataHandler";
import { BasePdfGenerator } from "../../../../utils/pdf/BasePdfGenerator";
import {
  applyHeaderStyles,
  buildAutoNote,
  buildAutoTable,
  generateCurrencyLabel,
} from "../../../../utils/pdf/buildAutoTable";
import {
  beautyAutoLine,
  boldAutoColumn,
  lineBreakText,
  redText,
} from "../../../../utils/pdf/page";
import {
  buildMainComputation,
  getForeignIncomeCurrencyDetails,
} from "../../ForeignTaxCredit/calculation";
import { fieldMap } from "../../ForeignTaxCredit/MainCompFtcBreakdown";
import {
  calculateTotalsByIncomeType,
  groupByIncomeType,
  getCountry,
} from "../calculations";
import { buildGroupedRows, buildGroupSubtotal } from "../TrackerForm";

const footerSettings = false;

export const generateUnremittedForeignPdf = (
  forView,
  schedule,
  company,
  currentYearUnremittedForeignRows,
  previousYearUnremittedForeignRows,
  foreignSourceTrackingRows,
  trackingSubtotals,
  summaryData,
  foreignTaxCreditScheduleRef,
  notes,
  reviewNotes,
  isExcel = false
) => {
  const pdf = new BasePdfGenerator(true, isExcel);
  const currencyLabel = generateCurrencyLabel(company.currency);

  if (
    currentYearUnremittedForeignRows &&
    currentYearUnremittedForeignRows.length > 0
  ) {
    const labelColumns = [
      "",
      "",
      "",
      currencyLabel,
      currencyLabel,
      currencyLabel,
      "",
      "",
    ];
    let contentColumns = [
      [
        "Schedule Name",
        "Income Type",
        "Country",
        "Available Income",
        "Allowable Expenses",
        "Foreign Tax Suffered",
        "Sch",
      ],
      labelColumns,
    ];
    let totalLines = [];
    let totalDoubleLines = [];

    if (forView) {
      contentColumns[0].push(redText("Reference"));
    }
    let contentData = [];

    if (isExcel) {
      contentData.push(labelColumns);
    }

    currentYearUnremittedForeignRows.map((row) => {
      let content = [
        row.source?.sch_name || "",
        row.incomeType || "Not specified",
        getCountry(row.country),
        formatAmount(row.amount),
        formatAmount(row.allowableExpenses),
        formatAmount(row.foreignTaxSuffered, false),
        row.source?.sch_no,
      ];
      if (forView) {
        content.push(redText(row.reference));
      }
      contentData.push(content);
    });
    let totalAmount = currentYearUnremittedForeignRows.reduce(
      (sum, row) => sum + parseFloat(row.amount || 0),
      0
    );
    let totalAllowableExpenses = currentYearUnremittedForeignRows.reduce(
      (sum, row) => sum + parseFloat(row.allowableExpenses || 0),
      0
    );
    let totalForeignTaxSuffered = currentYearUnremittedForeignRows.reduce(
      (sum, row) => sum + parseFloat(row.foreignTaxSuffered || 0),
      0
    );
    contentData.push([
      "",
      "",
      "",
      formatAmount(totalAmount),
      formatAmount(totalAllowableExpenses),
      formatAmount(totalForeignTaxSuffered, false),
    ]);
    totalLines.push(contentData.length - 2);
    totalLines.push(contentData.length - 1);
    totalDoubleLines.push(contentData.length - 1);

    if (contentData.length > 0) {
      const totalRows = [3, 4, 5];
      buildAutoTable({
        pdf,
        addPlainTitle: true,
        tableTitle: "Current Year Unremitted Foreign Income",
        head: contentColumns,
        body: contentData,
        schedule,
        company,
        columnStyles: {
          0: { halign: "left", minCellWidth: 30 },
          1: { halign: "center", minCellWidth: 20 },
          2: { halign: "center", minCellWidth: 20 },
          3: { halign: "right", minCellWidth: 24 },
          4: { halign: "right", minCellWidth: 24 },
          5: { halign: "right", minCellWidth: 24 },
          6: { halign: "center" },
          7: { halign: "center" },
        },
        didParseCell: (data) => {
          if (applyHeaderStyles(data, 0, [0])) {
            data.cell.styles.halign = "left";
          }

          if (isExcel) {
            if (data.row.index === 0 && [3, 4, 5].includes(data.column.index)) {
              data.cell.styles.halign = "center";
            }
          }

          // if (applyHeaderStyles(data, 1, [3, 4, 5])) {
          //   data.cell.styles.lineWidth = {
          //     bottom: 0.1,
          //   };
          //   data.cell.styles.lineColor = [0, 0, 0];
          // }
        },
        didDrawCell: (data) => {
          beautyAutoLine(
            data,
            pdf.doc,
            totalLines.includes(data.row.index) &&
              totalRows.includes(data.column.index),
            totalDoubleLines.includes(data.row.index) &&
              totalRows.includes(data.column.index)
          );
        },
        lineSettings: {
          totalLines,
          totalDoubleLines,
          totalRows,
          labelRows: [3, 4, 5],
        },
      });
    }
  }

  // if (
  //   previousYearUnremittedForeignRows &&
  //   previousYearUnremittedForeignRows.length > 0
  // ) {
  //   const labelColumns = [
  //     "",
  //     "",
  //     "",
  //     "",
  //     currencyLabel,
  //     currencyLabel,
  //     currencyLabel,
  //     "",
  //   ];
  //   let contentColumns = [
  //     [
  //       "Description",
  //       "Income Type",
  //       "Country",
  //       "YA Earned",
  //       "Available Income",
  //       "Allowable Expenses",
  //       "Foreign Tax Suffered",
  //       "Reference",
  //     ],
  //     labelColumns,
  //   ];
  //   let totalLines = [];
  //   let totalDoubleLines = [];

  //   if (forView) {
  //     // Reference column is already included
  //   }
  //   let contentData = [];

  //   if (isExcel) {
  //     contentData.push(labelColumns);
  //   }

  //   previousYearUnremittedForeignRows.map((row) => {
  //     let content = [
  //       row.description || "",
  //       row.incomeType || "Not specified",
  //       row.country || "Not specified",
  //       row.yaEarned || "",
  //       formatAmount(row.amount),
  //       formatAmount(row.allowableExpenses),
  //       formatAmount(row.foreignTaxSuffered, false),
  //       row.reference || "",
  //     ];
  //     contentData.push(content);
  //   });
  //   let totalAmount = previousYearUnremittedForeignRows.reduce(
  //     (sum, row) => sum + parseFloat(row.amount || 0),
  //     0
  //   );
  //   let totalAllowableExpenses = previousYearUnremittedForeignRows.reduce(
  //     (sum, row) => sum + parseFloat(row.allowableExpenses || 0),
  //     0
  //   );
  //   let totalForeignTaxSuffered = previousYearUnremittedForeignRows.reduce(
  //     (sum, row) => sum + parseFloat(row.foreignTaxSuffered || 0),
  //     0
  //   );
  //   contentData.push([
  //     "",
  //     "",
  //     "",
  //     "",
  //     formatAmount(totalAmount),
  //     formatAmount(totalAllowableExpenses),
  //     formatAmount(totalForeignTaxSuffered, false),
  //     "",
  //   ]);
  //   totalLines.push(contentData.length - 2);
  //   totalLines.push(contentData.length - 1);
  //   totalDoubleLines.push(contentData.length - 1);

  //   if (contentData.length > 0) {
  //     const totalRows = [4, 5, 6];
  //     buildAutoTable({
  //       pdf,
  //       addPlainTitle: true,
  //       tableTitle: "Previous Year Unremitted Foreign Income",
  //       customStartY: pdf.startY + 2,
  //       head: contentColumns,
  //       body: contentData,
  //       schedule,
  //       company,
  //       columnStyles: {
  //         0: { halign: "left", minCellWidth: 30 },
  //         1: { halign: "center", minCellWidth: 20 },
  //         2: { halign: "center", minCellWidth: 20 },
  //         3: { halign: "center", minCellWidth: 15 },
  //         4: { halign: "right", minCellWidth: 24 },
  //         5: { halign: "right", minCellWidth: 24 },
  //         6: { halign: "right", minCellWidth: 24 },
  //         7: { halign: "left", minCellWidth: 20 },
  //       },
  //       didParseCell: (data) => {
  //         if (applyHeaderStyles(data, 0, [0])) {
  //           data.cell.styles.halign = "left";
  //         }

  //         if (isExcel) {
  //           if (data.row.index === 0 && [4, 5, 6].includes(data.column.index)) {
  //             data.cell.styles.halign = "center";
  //           }
  //         }
  //       },
  //       didDrawCell: (data) => {
  //         beautyAutoLine(
  //           data,
  //           pdf.doc,
  //           totalLines.includes(data.row.index) &&
  //             totalRows.includes(data.column.index),
  //           totalDoubleLines.includes(data.row.index) &&
  //             totalRows.includes(data.column.index)
  //         );
  //       },
  //       lineSettings: {
  //         totalLines,
  //         totalDoubleLines,
  //         totalRows,
  //         labelRows: [4, 5, 6],
  //       },
  //     });
  //   }
  // }

  if (foreignSourceTrackingRows && foreignSourceTrackingRows.length > 0) {
    const labelColumns = [
      "",
      "",
      "",
      currencyLabel,
      currencyLabel,
      currencyLabel,
      currencyLabel,
      currencyLabel,
      currencyLabel,
      currencyLabel,
      currencyLabel,
      currencyLabel,
      currencyLabel,
      currencyLabel,
      currencyLabel,
      currencyLabel,
    ];

    let contentColumns = [
      [
        "Income Type",
        "Country",
        "YA",
        "Available Income (A)",
        "Received in SG (B)",
        "Used not Received (C)",
        "Unremitted c/f (D)",
        "Available Expenses (E)",
        "Exp. Remitted (F)",
        "Exp. Non-Rem. (G)",
        "Expenses c/f (H)",
        "Net Income (I)",
        "Available Foreign Tax (J)",
        "FTC Remitted (K)",
        "FTC Non-Rem. (L)",
        "Foreign Tax c/f (M)",
      ],
      labelColumns,
    ];

    let contentData = [];
    let totalLines = [];
    let totalDoubleLines = [];

    if (isExcel) {
      contentData.push(labelColumns);
    }

    const groupedRows = buildGroupedRows({
      data: foreignSourceTrackingRows,
      groupByFn: groupByIncomeType,
      subtotalFn: buildGroupSubtotal,
      totalsByTypeFn: calculateTotalsByIncomeType,
      groupHeaderKey: "incomeType",
      subtotalOverrides: (subtotal, calcTotals) => {
        return {
          ...subtotal,
          netIncomeReceived: calcTotals.totalNetIncome,
          shareOfForeignTaxSufferedRemitted: calcTotals.totalForeignTax,
        };
      },
    });

    groupedRows.map((row, index) => {
      if (row.__group) {
        if (index !== 0) contentData.push([]);
        // Group header row - add income type as a row
        contentData.push([
          {
            content: row.incomeType === "" ? "Unspecified" : row.incomeType,
            colSpan: 3,
            styles: {
              fontStyle: "bold",
              overflow: "lineBreak",
            },
          },
        ]);
      } else if (row.__subtotal) {
        // Subtotal row - add calculated totals
        const availableIncome =
          (row.unremittedIncomeBf || 0) + (row.currentYearIncome || 0);
        const availableExpenses =
          (row.allowableExpensesBf || 0) +
          (row.currentYearAllowableExpenses || 0);
        const availableForeignTax =
          (row.foreignTaxSufferedBf || 0) + (row.foreignTaxSuffered || 0);
        contentData.push([
          {
            content: row.incomeType,
            colSpan: 3,
            styles: {
              fontStyle: "bold",
              overflow: "lineBreak",
            },
          },
          formatAmount(availableIncome),
          formatAmount(row.incomeReceived),
          formatAmount(row.incomeUsedNotReceived),
          formatAmount(row.unremittedIncomeCf),
          formatAmount(availableExpenses),
          formatAmount(row.shareOfExpensesRemitted),
          formatAmount(row.shareOfExpensesNonRemitted),
          formatAmount(row.allowableExpensesCf),
          formatAmount(row.netIncomeReceived),
          formatAmount(availableForeignTax, false),
          formatAmount(row.shareOfForeignTaxSufferedRemitted || 0, false),
          formatAmount(row.shareOfForeignTaxSufferedNonRemitted || 0, false),
          formatAmount(row.foreignTaxSufferedCf || 0, false),
        ]);
        // Mark this row for total line styling
        totalLines.push(contentData.length - 2);
      } else {
        // Regular data row - add all field values with combined columns
        const availableIncome =
          (row.unremittedIncomeBf || 0) + (row.currentYearIncome || 0);
        const availableExpenses =
          (row.allowableExpensesBf || 0) +
          (row.currentYearAllowableExpenses || 0);
        const availableForeignTax =
          (row.foreignTaxSufferedBf || 0) + (row.foreignTaxSuffered || 0);
        contentData.push([
          row.incomeType || "",
          getCountry(row.country),
          row.yaEarned || "",
          formatAmount(availableIncome),
          formatAmount(row.incomeReceived),
          formatAmount(row.incomeUsedNotReceived),
          formatAmount(row.unremittedIncomeCf),
          formatAmount(availableExpenses),
          formatAmount(row.shareOfExpensesRemitted),
          formatAmount(row.shareOfExpensesNonRemitted),
          formatAmount(row.allowableExpensesCf),
          formatAmount(row.netIncomeReceived),
          formatAmount(availableForeignTax, false),
          formatAmount(row.shareOfForeignTaxSufferedRemitted || 0, false),
          formatAmount(row.shareOfForeignTaxSufferedNonRemitted || 0, false),
          formatAmount(row.foreignTaxSufferedCf || 0, false),
        ]);
      }
    });

    if (groupedRows.length > 0) {
      contentData.push([]);
      totalLines.push(contentData.length - 1);
      const availableIncomeTotal =
        (trackingSubtotals.unremittedIncomeBf || 0) +
        (trackingSubtotals.currentYearIncome || 0);
      const availableExpensesTotal =
        (trackingSubtotals.allowableExpensesBf || 0) +
        (trackingSubtotals.currentYearAllowableExpenses || 0);
      const availableForeignTaxTotal =
        (trackingSubtotals.foreignTaxSufferedBf || 0) +
        (trackingSubtotals.foreignTaxSuffered || 0);
      contentData.push([
        {
          content: "Total of all income types",
          styles: {
            fontStyle: "bold",
            overflow: "lineBreak",
          },
        },
        "",
        "",
        formatAmount(availableIncomeTotal),
        formatAmount(trackingSubtotals.incomeReceived || 0),
        formatAmount(trackingSubtotals.incomeUsedNotReceived || 0),
        formatAmount(trackingSubtotals.unremittedIncomeCf || 0),
        formatAmount(availableExpensesTotal),
        formatAmount(trackingSubtotals.shareOfExpensesRemitted || 0),
        formatAmount(trackingSubtotals.shareOfExpensesNonRemitted || 0),
        formatAmount(trackingSubtotals.allowableExpensesCf || 0),
        formatAmount(trackingSubtotals.netIncomeReceived || 0),
        formatAmount(availableForeignTaxTotal, false),
        formatAmount(
          trackingSubtotals.shareOfForeignTaxSufferedRemitted || 0,
          false
        ),
        formatAmount(
          trackingSubtotals.shareOfForeignTaxSufferedNonRemitted || 0,
          false
        ),
        formatAmount(trackingSubtotals.foreignTaxSufferedCf || 0, false),
      ]);
      totalLines.push(contentData.length - 1);
      totalDoubleLines.push(contentData.length - 1);
    }

    contentData.push([]);
    contentData.push([
      lineBreakText(
        [
          "Formula:",
          "Unremitted income c/f (D) = (A) - (B) - (C)",
          "Share of Expenses Remitted (F) = (B) / (A) x (E), Share of Expenses for Non-Remitted Income (G) = (C) / (A) x (E), Allowable Expenses c/f (H) = (E) - (F) - (G)",
          "Net Income (I) = (B) - (F)",
          "Share of Tax Remitted (K) = (B) / (A) x (J), Share of Tax for Non-Remitted Income (L) = (C) / (A) x (J), Foreign Tax c/f (M) = (J) - (K) - (L)",
        ].join("\n")
      ),
    ]);

    const totalRows = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    buildAutoTable({
      pdf,
      addPlainTitle: true,
      tableTitle: "Unremitted Foreign Income Tracker",
      customStartY: pdf.startY + 2,
      customFs: 8,
      head: contentColumns,
      body: contentData,
      schedule,
      company,
      columnStyles: {
        0: { halign: "left", cellWidth: 32 },
        1: { halign: "center", minCellWidth: 15 },
        2: { halign: "center", minCellWidth: 10 },
        3: { halign: "right", minCellWidth: 15 },
        4: { halign: "right", minCellWidth: 15 },
        5: { halign: "right", minCellWidth: 15 },
        6: { halign: "right", minCellWidth: 15 },
        7: { halign: "right", minCellWidth: 15 },
        8: { halign: "right", minCellWidth: 15 },
        9: { halign: "right", minCellWidth: 15 },
        10: { halign: "right", minCellWidth: 15 },
        11: { halign: "right", minCellWidth: 15 },
        12: { halign: "right", minCellWidth: 15 },
        13: { halign: "right", minCellWidth: 15 },
        14: { halign: "right", minCellWidth: 15 },
        15: { halign: "right", minCellWidth: 15 },
      },
      didParseCell: (data) => {
        if (data.row.index === 0 && [0].includes(data.column.index)) {
          data.cell.styles.halign = "left";
        }
        if (applyHeaderStyles(data, 0, totalRows)) {
          data.cell.styles.halign = "center";
        }
        // Highlight income columns (3, 4, 5, 6) in light green
        if (applyHeaderStyles(data, 0, [3, 4, 5, 6])) {
          data.cell.styles.fillColor = [225, 245, 230];
        }
        // Highlight expense columns (7, 8, 9, 10) in light red
        if (applyHeaderStyles(data, 0, [7, 8, 9, 10])) {
          data.cell.styles.fillColor = [255, 240, 240];
        }
        // Highlight foreign tax columns (12, 13, 14, 15) in light blue
        if (applyHeaderStyles(data, 0, [11, 12, 13, 14, 15])) {
          data.cell.styles.fillColor = [230, 240, 255];
        }

        if (isExcel) {
          if (data.row.index === 0 && totalRows.includes(data.column.index)) {
            data.cell.styles.halign = "center";
          }
        }
      },
      didDrawCell: (data) => {
        beautyAutoLine(
          data,
          pdf.doc,
          totalLines.includes(data.row.index) &&
            totalRows.includes(data.column.index),
          totalDoubleLines.includes(data.row.index) &&
            totalRows.includes(data.column.index)
        );
      },
      lineSettings: {
        totalLines,
        totalDoubleLines,
        totalRows,
        labelRows: totalRows,
      },
    });
  }

  // Add Tracker Summary section
  if (summaryData && Object.keys(summaryData).length > 0) {
    const labelColumns = [
      "",
      "",
      currencyLabel,
      currencyLabel,
      currencyLabel,
      currencyLabel,
    ];
    let summaryColumns = [
      [
        "Income Type",
        "Country",
        "Income Received (Remitted)",
        "Share of Expenses (Remitted)",
        "Net Remitted Income",
        "Foreign Tax Allocated to Remitted Income",
      ],
      labelColumns,
    ];
    let summaryTableData = [];
    if (isExcel) {
      summaryTableData.push(labelColumns);
    }

    let summaryTotalLines = [];
    let summaryTotalDoubleLines = [];

    // Track grand totals
    let grandTotals = {
      incomeReceived: 0,
      shareOfExpensesRemitted: 0,
      netIncomeReceived: 0,
      shareOfForeignTaxSuffered: 0,
    };

    // Iterate through each income type
    Object.keys(summaryData).forEach((incomeType) => {
      const countries = summaryData[incomeType];
      let incomeTypeSubtotals = {
        incomeReceived: 0,
        shareOfExpensesRemitted: 0,
        netIncomeReceived: 0,
        shareOfForeignTaxSuffered: 0,
      };

      // Add rows for each country under this income type
      Object.keys(countries).forEach((country) => {
        const countryData = countries[country];
        // Only include rows where incomeReceived > 0
        if ((countryData.incomeReceived || 0) > 0) {
          const incomeReceived = countryData.incomeReceived || 0;
          const shareOfExpensesRemitted =
            countryData.shareOfExpensesRemitted || 0;
          const netIncomeReceived = countryData.netIncomeReceived || 0;
          const shareOfForeignTaxSufferedRemitted =
            countryData.shareOfForeignTaxSufferedRemitted || 0;

          summaryTableData.push([
            incomeType || "Unspecified",
            country || "Unspecified",
            formatAmount(incomeReceived),
            formatAmount(shareOfExpensesRemitted),
            formatAmount(netIncomeReceived),
            formatAmount(shareOfForeignTaxSufferedRemitted, false),
          ]);

          // Accumulate subtotals for this income type
          incomeTypeSubtotals.incomeReceived += incomeReceived;
          incomeTypeSubtotals.shareOfExpensesRemitted +=
            shareOfExpensesRemitted;
          incomeTypeSubtotals.netIncomeReceived += netIncomeReceived;
          incomeTypeSubtotals.shareOfForeignTaxSuffered +=
            shareOfForeignTaxSufferedRemitted;

          // Accumulate grand totals
          grandTotals.incomeReceived += incomeReceived;
          grandTotals.shareOfExpensesRemitted += shareOfExpensesRemitted;
          grandTotals.netIncomeReceived += netIncomeReceived;
          grandTotals.shareOfForeignTaxSuffered +=
            shareOfForeignTaxSufferedRemitted;
        }
      });

      // Add subtotal row for this income type (if there are rows)
      if (incomeTypeSubtotals.netIncomeReceived > 0) {
        summaryTotalLines.push(summaryTableData.length);
        summaryTableData.push([
          `${incomeType || "Unspecified"} - Total`,
          "",
          formatAmount(incomeTypeSubtotals.incomeReceived),
          formatAmount(incomeTypeSubtotals.shareOfExpensesRemitted),
          formatAmount(incomeTypeSubtotals.netIncomeReceived),
          formatAmount(incomeTypeSubtotals.shareOfForeignTaxSuffered, false),
        ]);
      }
    });

    // Add grand totals row
    let addedBackRowIndex = -1;
    if (summaryTableData.length > 0) {
      summaryTotalLines.push(summaryTableData.length - 1);
      summaryTotalLines.push(summaryTableData.length);
      summaryTotalDoubleLines.push(summaryTableData.length);
      summaryTableData.push([
        "",
        "",
        formatAmount(grandTotals.incomeReceived),
        formatAmount(grandTotals.shareOfExpensesRemitted),
        formatAmount(grandTotals.netIncomeReceived),
        formatAmount(grandTotals.shareOfForeignTaxSuffered, false),
      ]);

      // Add "Added back/Main Comp" row under Net Income column
      addedBackRowIndex = summaryTableData.length;
      summaryTableData.push([
        "",
        "",
        "",
        "",
        lineBreakText("Added back / Main Comp", { top: 3, bottom: 0 }),
        lineBreakText(foreignTaxCreditScheduleRef || "", { top: 3, bottom: 0 }),
      ]);
    }

    if (summaryTableData.length > 0) {
      const totalRows = [2, 3, 4, 5];
      buildAutoTable({
        pdf,
        addPlainTitle: true,
        tableTitle: "Foreign Income Tracker Summary",
        customStartY: pdf.startY + 5,
        head: summaryColumns,
        body: summaryTableData,
        schedule,
        company,
        columnStyles: {
          0: { halign: "left", minCellWidth: 30 },
          1: { halign: "left", minCellWidth: 25 },
          2: { halign: "right", cellWidth: 40 },
          3: { halign: "right", cellWidth: 40 },
          4: { halign: "right", cellWidth: 40 },
          5: { halign: "right", cellWidth: 40 },
        },
        didParseCell: (data) => {
          if (applyHeaderStyles(data, 0, [0, 1])) {
            data.cell.styles.halign = "left";
          }

          // Make subtotal and grand total rows bold
          if (
            summaryTotalLines.includes(data.row.index) ||
            summaryTotalDoubleLines.includes(data.row.index)
          ) {
            data.cell.styles.fontStyle = "bold";
          }

          // Style "Added back/Main Comp" row - left align in Net Income column
          if (
            addedBackRowIndex >= 0 &&
            data.row.index === addedBackRowIndex &&
            data.column.index === 4
          ) {
            data.cell.styles.halign = "right";
          }

          if (isExcel) {
            if (data.row.index === 0 && totalRows.includes(data.column.index)) {
              data.cell.styles.halign = "center";
            }
          }
        },
        didDrawCell: (data) => {
          beautyAutoLine(
            data,
            pdf.doc,
            summaryTotalLines.includes(data.row.index) &&
              totalRows.includes(data.column.index),
            summaryTotalDoubleLines.includes(data.row.index) &&
              totalRows.includes(data.column.index)
          );
        },
        lineSettings: {
          totalLines: summaryTotalLines,
          totalDoubleLines: summaryTotalDoubleLines,
          totalRows,
          labelRows: totalRows,
        },
      });
    }
  }

  buildAutoNote(
    pdf,
    forView,
    company,
    schedule,
    notes,
    reviewNotes,
    [],
    footerSettings
  );
  return pdf.getDoc(forView, company, schedule);
};

export const generateFtcPdf = (
  forView,
  schedule,
  company,
  functionalCurrency,
  functionalCurrencyRate,
  breakdownRows,
  foreignIncomeRows,
  foreignIncomeTotals,
  ftcCalculatedData,
  notes,
  reviewNotes,
  isExcel = false
) => {
  const pdf = new BasePdfGenerator(true, isExcel);
  functionalCurrency = functionalCurrency || company.currency || "SGD";
  functionalCurrencyRate = functionalCurrencyRate ?? company.currencyRate ?? 1;
  const currencyLabel = generateCurrencyLabel(functionalCurrency);

  if (foreignIncomeRows && foreignIncomeRows.length > 0) {
    let contentColumns = [
      "Description",
      "Income Type",
      "Country",
      "Gross Income",
      "Allowable Expenses",
      "Net Income",
    ];
    let labelColumns = [
      "",
      "",
      "",
      currencyLabel,
      currencyLabel,
      currencyLabel,
    ];

    if (functionalCurrency !== "SGD") {
      contentColumns.push("Currency", "Exchange Rate");
      labelColumns.push("", "");
    }

    contentColumns.push(`Foreign Tax Suffered`);
    labelColumns.push(currencyLabel);

    if (functionalCurrency !== "SGD") {
      contentColumns.push("Foreign Tax Suffered");
      labelColumns.push("SGD");
    }

    contentColumns.push("FTC Pooling");
    labelColumns.push("");

    if (forView) {
      contentColumns.push("Reference", "Sch");
      labelColumns.push("", "");
    }

    let totalLines = [];
    let totalDoubleLines = [];

    let contentData = [];
    if (isExcel) {
      contentData.push(labelColumns);
    }

    foreignIncomeRows.forEach((row) => {
      let content = [
        row.isPopulated ? row.source?.sch_name : row.scheduleName,
        row.incomeType,
        row.country,
        formatAmount(row.grossIncome),
        formatAmount(row.allowableExpenses),
        formatAmount(row.netIncome),
      ];
      if (functionalCurrency !== "SGD") {
        const { currency, exchangeRate } = getForeignIncomeCurrencyDetails(
          row,
          functionalCurrency,
          functionalCurrencyRate
        );
        content.push(currency, exchangeRate);
      }
      content.push(formatAmount(row.foreignTaxSuffered, false));
      if (functionalCurrency !== "SGD") {
        content.push(formatAmount(row.foreignTaxSufferedSGD, false));
      }

      content.push(row.ftcPooling ? "Yes" : "No");

      if (forView) {
        content.push(row.reference, row.source?.sch_no || "");
      }

      contentData.push(content);
    });

    totalLines.push(contentData.length - 1);

    let totalContent = [
      "",
      "",
      boldAutoColumn("Total"),
      formatAmount(foreignIncomeTotals?.grossIncome || 0),
      formatAmount(foreignIncomeTotals?.allowableExpenses || 0),
      formatAmount(foreignIncomeTotals?.netIncome || 0),
    ];

    if (functionalCurrency !== "SGD") {
      totalContent.push("", "");
    }

    totalContent.push(
      formatAmount(foreignIncomeTotals?.foreignTaxSuffered || 0, false)
    );

    if (functionalCurrency !== "SGD") {
      totalContent.push(
        formatAmount(foreignIncomeTotals?.foreignTaxSufferedSGD || 0, false)
      );
    }

    contentData.push(totalContent);

    totalLines.push(contentData.length - 1);
    totalDoubleLines.push(contentData.length - 1);

    let columnStyles =
      functionalCurrency === "SGD"
        ? {
            0: { halign: "left", minCellWidth: 30 },
            1: { halign: "center", minCellWidth: 20 },
            2: { halign: "center", minCellWidth: 20 },
            3: { halign: "right", cellWidth: 30 },
            4: { halign: "right", cellWidth: 30 },
            5: { halign: "right", cellWidth: 30 },
            6: { halign: "right", cellWidth: 30 },
            7: { halign: "center", cellWidth: 18 },
            8: { halign: "center" },
            9: { halign: "center" },
          }
        : {
            0: { halign: "left" },
            1: { halign: "center" },
            2: { halign: "center" },
            4: { halign: "right", cellWidth: 24 },
            3: { halign: "right", cellWidth: 24 },
            5: { halign: "right", cellWidth: 24 },
            6: { halign: "center", cellWidth: 20 },
            7: { halign: "center", cellWidth: 20 },
            8: { halign: "right", cellWidth: 24 },
            9: { halign: "right", cellWidth: 24 },
            10: { halign: "center", cellWidth: 18 },
            11: { halign: "center" },
            12: { halign: "center" },
          };

    const rowNeedLines =
      functionalCurrency === "SGD" ? [3, 4, 5, 6] : [3, 4, 5, 8, 9];

    buildAutoTable({
      pdf,
      addPlainTitle: true,
      tableTitle: "Foreign Income",
      head: [contentColumns, labelColumns],
      body: contentData,
      schedule,
      company,
      columnStyles: columnStyles,
      didParseCell: (data) => {
        if (data.row.index === 0 && [0].includes(data.column.index)) {
          data.cell.styles.halign = "left";
        }

        if (isExcel) {
          if (
            data.row.index === 0 &&
            rowNeedLines.includes(data.column.index)
          ) {
            data.cell.styles.halign = "center";
          }
        }
      },
      didDrawCell: (data) => {
        beautyAutoLine(
          data,
          pdf.doc,
          totalLines.includes(data.row.index) &&
            rowNeedLines.includes(data.column.index),
          totalDoubleLines.includes(data.row.index) &&
            rowNeedLines.includes(data.column.index)
        );
      },
      lineSettings: {
        totalLines,
        totalDoubleLines,
        totalRows: rowNeedLines,
        labelRows: rowNeedLines,
      },
    });

    if (breakdownRows) {
      let breakdownColumns = [
        "Main Computation Section",
        "Section ID",
        "Amount",
      ];
      let breakdownLabelColumns = ["", "", currencyLabel];

      let breakdownContentData = [];
      if (isExcel) {
        breakdownContentData.push(breakdownLabelColumns);
      }

      const data = buildMainComputation(
        foreignIncomeRows,
        breakdownRows,
        company.companyType
      );
      data.rows.forEach((row) => {
        let description = row.description;
        if (row.country) {
          description += `\nCountry: ${row.country}`;
        }

        breakdownContentData.push([
          description,
          row.section,
          `${["F"].includes(row.section) ? `S$ ` : ""}${formatAmount(
            row.isReadOnly ? row.value : breakdownRows[fieldMap[row.id]],
            row.id !== "tax-payable"
          )}`,
        ]);
      });

      // Add empty row for spacing
      breakdownContentData.push([]);

      // Add totals row if computed data is available
      if (breakdownRows.computedData) {
        breakdownContentData.push([
          boldAutoColumn("Total"),
          "",
          formatAmount(breakdownRows.computedData.statutoryIncome),
        ]);
      }

      buildAutoTable({
        pdf,
        addPlainTitle: true,
        tableTitle: "Main Computation FTC Breakdown",
        customStartY: pdf.startY + 8,
        head: [breakdownColumns, breakdownLabelColumns],
        body: breakdownContentData,
        schedule,
        company,
        columnStyles: {
          0: { halign: "left", minCellWidth: 40 },
          1: { halign: "center", minCellWidth: 15 },
          2: { halign: "right", cellWidth: 30 },
        },
        didParseCell: (data) => {
          if (data.row.index === 0 && [0].includes(data.column.index)) {
            data.cell.styles.halign = "left";
          }

          if (isExcel) {
            if (data.row.index === 0 && [2].includes(data.column.index)) {
              data.cell.styles.halign = "center";
            }
          }
        },
        lineSettings: {
          labelRows: [2],
        },
      });
    }
  }

  // Add FTC Summary section
  if (ftcCalculatedData && Object.keys(ftcCalculatedData).length > 0) {
    let summaryColumns = [
      "Calculation Method",
      "Description",
      "Calculation Steps",
      "Singapore Tax",
      ...(functionalCurrency !== "SGD"
        ? [`Foreign Tax (${functionalCurrency})`, "Foreign Tax (SGD)"]
        : ["Foreign Tax"]),
      "FTC Amount",
    ];

    let summaryLabelColumns = [
      "",
      "",
      "",
      "$",
      ...(functionalCurrency !== "SGD" ? [currencyLabel, "$"] : ["$"]),
      "$",
    ];

    let summaryData = [];
    if (isExcel) {
      summaryData.push(summaryLabelColumns);
    }
    let sgTaxTotalLines = [];
    let summaryTotalLines = [];
    let foreignTaxTotalLines = [];
    let summaryTotalDoubleLines = [];

    // Add Method 1 (Country-by-Country) results
    if (
      ftcCalculatedData.method1Results &&
      ftcCalculatedData.method1Results.length > 0
    ) {
      ftcCalculatedData.method1Results.forEach((result) => {
        const calculationSteps =
          result.calculationSteps && result.calculationSteps.length > 0
            ? result.calculationSteps[2]
            : "";
        summaryData.push([
          "Country-by-Country",
          result.description,
          calculationSteps,
          formatAmount(result.singaporeTax, false),
          ...(functionalCurrency !== "SGD"
            ? [
                formatAmount(result.originForeignTax, false),
                formatAmount(result.foreignTax, false),
              ]
            : [formatAmount(result.foreignTax, false)]),
          formatAmount(result.ftcAmount, false),
        ]);
      });

      // Add Method 1 subtotal
      summaryData.push([
        "",
        "",
        boldAutoColumn("Subtotal"),
        "",
        ...(functionalCurrency !== "SGD" ? ["", ""] : [""]),
        boldAutoColumn(formatAmount(ftcCalculatedData.totalMethod1FTC, false)),
      ]);
      summaryTotalLines.push(summaryData.length - 2);
      summaryData.push([]);
    }

    // Add Method 2 (Pooling) results
    if (
      ftcCalculatedData.method2Results &&
      ftcCalculatedData.method2Results.length > 0
    ) {
      ftcCalculatedData.method2Results.forEach((result) => {
        const calculationSteps =
          result.calculationSteps && result.calculationSteps.length > 0
            ? result.calculationSteps[2]
            : "";
        summaryData.push([
          "FTC Pooling",
          result.description,
          calculationSteps,
          formatAmount(result.singaporeTax, false),
          ...(functionalCurrency !== "SGD"
            ? [
                formatAmount(result.originForeignTax, false),
                formatAmount(result.foreignTax, false),
              ]
            : [formatAmount(result.foreignTax, false)]),
          "",
        ]);
      });

      // Add Method 2 subtotal
      summaryData.push([
        "",
        "",
        boldAutoColumn("Subtotal"),
        boldAutoColumn(
          formatAmount(ftcCalculatedData.totalMethod2SingaporeTax, false)
        ),
        ...(functionalCurrency !== "SGD"
          ? [
              boldAutoColumn(
                formatAmount(
                  ftcCalculatedData.totalMethod2OriginForeignTax,
                  false
                )
              ),
              boldAutoColumn(
                formatAmount(ftcCalculatedData.totalMethod2ForeignTax, false)
              ),
            ]
          : [
              boldAutoColumn(
                formatAmount(ftcCalculatedData.totalMethod2ForeignTax, false)
              ),
            ]),
        boldAutoColumn(formatAmount(ftcCalculatedData.totalMethod2FTC, false)),
      ]);
      sgTaxTotalLines.push(summaryData.length - 2);
      foreignTaxTotalLines.push(summaryData.length - 2);
    }

    // Add grand total
    if (summaryData.length > 0) {
      summaryData.push([
        "",
        "",
        boldAutoColumn("Total Claimable FTC"),
        "",
        ...(functionalCurrency !== "SGD" ? ["", ""] : [""]),
        boldAutoColumn(formatAmount(ftcCalculatedData.totalFTC, false)),
      ]);
      summaryTotalLines.push(summaryData.length - 2);
      summaryTotalLines.push(summaryData.length - 1);
      summaryTotalDoubleLines.push(summaryData.length - 1);
    }

    if (summaryData.length > 0) {
      buildAutoTable({
        pdf,
        addPlainTitle: true,
        tableTitle: "Foreign Tax Credit Summary",
        customStartY: pdf.startY + 5,
        head: [summaryColumns, summaryLabelColumns],
        body: summaryData,
        schedule,
        company,
        columnStyles: {
          0: { halign: "left", minCellWidth: 25 },
          1: { halign: "left", minCellWidth: 40 },
          2: { halign: "left", minCellWidth: 35 },
          3: { halign: "right", minCellWidth: 20 },
          4: { halign: "right", minCellWidth: 20 },
          5: { halign: "right", minCellWidth: 20 },
          6: { halign: "right", minCellWidth: 20 },
        },
        didParseCell: (data) => {
          if (data.row.index === 0 && [0, 1, 2].includes(data.column.index)) {
            data.cell.styles.halign = "left";
          }

          if (isExcel) {
            if (
              data.row.index === 0 &&
              [3, 4, 5, 6].includes(data.column.index)
            ) {
              data.cell.styles.halign = "center";
            }
          }
        },
        didDrawCell: (data) => {
          beautyAutoLine(
            data,
            pdf.doc,
            (foreignTaxTotalLines.includes(data.row.index) &&
              (functionalCurrency !== "SGD" ? [3, 4, 5] : [3, 4]).includes(
                data.column.index
              )) ||
              (sgTaxTotalLines.includes(data.row.index) &&
                (functionalCurrency !== "SGD" ? [3, 4, 5] : [3, 4]).includes(
                  data.column.index
                )) ||
              (summaryTotalLines.includes(data.row.index) &&
                [functionalCurrency !== "SGD" ? 6 : 5].includes(
                  data.column.index
                )),
            summaryTotalDoubleLines.includes(data.row.index) &&
              [functionalCurrency !== "SGD" ? 6 : 5].includes(data.column.index)
          );
        },
        lineSettings: {
          totalLines: summaryTotalLines,
          totalDoubleLines: summaryTotalDoubleLines,
          totalRows: [functionalCurrency !== "SGD" ? 6 : 5],
          labelRows: [3, 4, 5, 6],
        },
      });
    }
  }

  buildAutoNote(
    pdf,
    forView,
    company,
    schedule,
    notes,
    reviewNotes,
    [],
    footerSettings
  );
  return pdf.getDoc(forView, company, schedule);
};
